import React from 'react';
import { RouteComponentProps, withRouter } from 'react-router';
import OrdersTab from './OrdersTab';
import RoutePlanTab from './RoutePlanTab';
import WarehouseTab from './WarehouseTab';
import ForecastTab from './ForecastTab';
import { PageHeader } from '../../../components/admin/Shared';

type Tab = 'orders' | 'route-plan' | 'warehouse' | 'forecast';

const TABS: { id: Tab; label: string; path: string }[] = [
  { id: 'orders', label: 'Orders', path: '/admin/logistics' },
  { id: 'route-plan', label: 'Route Plan', path: '/admin/logistics/route-plan' },
  { id: 'warehouse', label: 'Warehouse', path: '/admin/logistics/warehouse' },
  { id: 'forecast', label: 'Forecast', path: '/admin/logistics/forecast' },
];

// Legacy paths resolve to the same tabs so existing bookmarks keep working.
const LEGACY_PATHS: Record<string, Tab> = {
  '/admin/route-plan': 'route-plan',
  '/admin/warehouse': 'warehouse',
  '/admin/warehouse-forecast': 'forecast',
};

function resolveTab(pathname: string): Tab {
  if (LEGACY_PATHS[pathname]) return LEGACY_PATHS[pathname];
  const match = TABS.find((t) => pathname === t.path);
  return match ? match.id : 'orders';
}

function LogisticsPage({ history, location }: RouteComponentProps) {
  const active: Tab = resolveTab(location.pathname);

  const renderTab = () => {
    switch (active) {
      case 'orders':
        return <OrdersTab />;
      case 'route-plan':
        return <RoutePlanTab />;
      case 'warehouse':
        return <WarehouseTab />;
      case 'forecast':
        return <ForecastTab />;
    }
  };

  return (
    <>
      <PageHeader
        title="Logistics"
        onBack={() => history.push('/admin/dashboard')}
      />

      <div className="admin-tab-bar">
        {TABS.map((t) => (
          <button
            key={t.id}
            type="button"
            className={
              active === t.id
                ? 'admin-tab-bar__tab admin-tab-bar__tab--active'
                : 'admin-tab-bar__tab'
            }
            onClick={() => history.push(t.path)}
          >
            {t.label}
          </button>
        ))}
      </div>

      {renderTab()}
    </>
  );
}

export default withRouter(LogisticsPage);
